import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=1dab7336&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=1dab7336&prod&scoped=true&lang=css"
import style1 from "./FollowUp.vue?vue&type=style&index=1&id=1dab7336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab7336",
  null
  
)

export default component.exports